var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTiktok(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M4.167,0l21.667,0c2.301,0 4.167,1.865 4.167,4.167l0,21.667c0,2.301 -1.865,4.167 -4.167,4.167l-21.667,0c-2.301,0 -4.167,-1.865 -4.167,-4.167l0,-21.667c0,-2.301 1.865,-4.167 4.167,-4.167Z",
    style: {
      fill: "#4e87ae",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.392,8.738c-1.126,-0.734 -1.939,-1.909 -2.192,-3.278c-0.055,-0.296 -0.085,-0.601 -0.085,-0.912l-3.594,0l-0.006,14.403c-0.061,1.613 -1.387,2.908 -3.015,2.908c-0.506,0 -0.982,-0.127 -1.401,-0.347c-0.961,-0.506 -1.62,-1.514 -1.62,-2.674c0,-1.666 1.355,-3.021 3.021,-3.021c0.311,0 0.609,0.051 0.892,0.139l0,-3.669c-0.292,-0.04 -0.589,-0.065 -0.892,-0.065c-3.647,0 -6.615,2.968 -6.615,6.615c0,2.238 1.118,4.219 2.824,5.416c1.075,0.755 2.381,1.198 3.791,1.198c3.647,0 6.615,-2.967 6.615,-6.615l0,-7.303c1.409,1.012 3.136,1.608 5,1.608l0,-3.594c-1.003,0 -1.939,-0.299 -2.723,-0.81l-0.001,0.001Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTiktok);
export default __webpack_public_path__ + "static/media/icon_tiktok.60e7f6c3bd347df3d8d4e3425e4b65c1.svg";
export { ForwardRef as ReactComponent };